import en from "./en-US";
import de from "./de-DE";

export default {
  "en-US": en,
  "de-DE": de
};
